import React from 'react';
import { motion } from 'framer-motion';
type QuizProgressProps = {
  current: number;
  total: number;
};
export function QuizProgress({
  current,
  total
}: QuizProgressProps) {
  const percent = Math.round(current / total * 100);
  return <div className="w-full" data-id="element-74" data-mp="3mkap90zvdnji">
      <div className="flex items-baseline justify-between text-[0.7rem] uppercase tracking-[0.24em] text-warmgray-500" data-id="element-75" data-mp="3hjwfneime5jd">
        <span data-id="element-76" data-mp="3vj5ua9r6grl8">
          Pregunta {current} de {total}
        </span>
        <span className="text-sage-600" data-id="element-77" data-mp="3vhbaiyrn75iq">{percent}%</span>
      </div>

      <div className="mt-4 h-px w-full bg-sage-200" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Progreso del diagnóstico" data-id="element-78" data-mp="3rhklp0loezgu">
        <motion.div className="h-px bg-sage-600" initial={false} animate={{
        width: `${percent}%`
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-79" data-mp="47cjuekb62hy" />
      </div>
    </div>;
}